import React from 'react';

import { ValueButton, ValueGroup } from '@candu-ai/craft/ui';
import { Flags, useFlags } from 'commons/hooks';
import { StepCards } from 'craft/resolvers/Flow/toolbox/StepCards';
import { createFormStep, useForm } from 'craft/state';

interface Props {
  nodeId: string;
}

export const MultistepFormToolbox = ({ nodeId }: Props) => {
  const { isMultistepForm, onAddStep } = useForm(nodeId);
  const { [Flags.MULTISTEP_FORMS]: withMultistepForms } = useFlags();

  if (!withMultistepForms) {
    return null;
  }

  if (!isMultistepForm) {
    return (
      <ValueGroup>
        <ValueButton onClick={onAddStep}>Add Step</ValueButton>
      </ValueGroup>
    );
  }

  return (
    <ValueGroup>
      <StepCards createStep={createFormStep} nodeId={nodeId} />
    </ValueGroup>
  );
};
